var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircleAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1745_30321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 28.3926C22.3967 28.3926 28.3929 22.3965 28.3929 14.9998C28.3929 7.60312 22.3967 1.60693 15 1.60693C7.60336 1.60693 1.60718 7.60312 1.60718 14.9998C1.60718 22.3965 7.60336 28.3926 15 28.3926Z",
    fill: "#FFF2F2",
    stroke: "#F97068",
    strokeWidth: 1.73116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16.243C17.588 16.243 19.686 14.145 19.686 11.5571C19.686 8.96906 17.588 6.87109 15 6.87109C12.4121 6.87109 10.3141 8.96906 10.3141 11.5571C10.3141 14.145 12.4121 16.243 15 16.243Z",
    fill: "white",
    stroke: "#F97068",
    strokeWidth: 1.73116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9378 25.788C20.7164 27.4251 17.9712 28.3926 15 28.3926C12.0288 28.3926 9.28361 27.4251 7.06226 25.788C7.50463 24.1219 8.4615 22.6331 9.80246 21.537C11.2693 20.338 13.1055 19.6831 15 19.6831C16.8945 19.6831 18.7307 20.338 20.1975 21.537C21.5385 22.6331 22.4953 24.1219 22.9378 25.788Z",
    fill: "white",
    stroke: "#F97068",
    strokeWidth: 1.73116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1745_30321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleAvatar);
export default __webpack_public_path__ + "static/media/user-circle-avatar.2efb7c3977349148fa0f21870eec4602.svg";
export { ForwardRef as ReactComponent };